// extracted by mini-css-extract-plugin
module.exports = {"Title":"Column_Title__pVwjQ","Column":"Column_Column__2yFri","Links":"Column_Links__1DMl6"};